import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BillInvoicePreview from "../components/BillInvoicePreview";


const BillInvoicePreviewPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Generated Bill' />

                <BillInvoicePreview />

            </MasterLayout>
        </>
    );
};

export default BillInvoicePreviewPage;
